export function getLogoUrl(saasname) {
    const baseName = saasname.replace(/\s+/g, '').toLowerCase();
    const pngPath = `assets/images/logos/${baseName}.png`;
    const svgPath = `assets/images/logos/${baseName}.svg`;
    const placeholderPath = 'assets/images/placeholder-logo.png'; // Add a placeholder image
    return [pngPath, svgPath, placeholderPath];
}
